// isFinite,
var isNil = function isNil(value) {
  /**
   * isNil(null) => true
   * isNil() => true
   */
  return value === null || value === undefined;
};

module.exports = isNil;


//////////////////
// WEBPACK FOOTER
// ./~/@antv/adjust/~/@antv/util/lib/type/is-nil.js
// module id = 362
// module chunks = 3